import { authEndpoints } from '@d3/contract';

/**
 * 부팅 · 세션에 쓰는 엔드포인트 — `@d3/contract` 의 `auth` 도메인(DD-46).
 * 부팅 게이트 · 토큰 갱신 · 로그아웃 · 로그인 · 대리 로그인이 같은 정의를 쓴다.
 */
export type {
  GetAppStatusResponse,
  ImpersonateRequest,
  LoginRequest,
  RefreshSessionRequest,
  SessionResponse as RefreshSessionResponse,
  SendLoginCodeRequest,
  SessionResponse,
  SessionUser,
} from '@d3/contract';

export const sessionEndpoints = authEndpoints;
